'use client';
import dynamic from 'next/dynamic';
import HireProcess from '@/components/technologies/hire-process';
import ModelsOfWorking from '@/components/technologies/models-of-working';
import TechnologyFaq from '@/components/technologies/technology-faq';
import CaseStudies from '@/components/common/case-study-section';
import ClientTestimonials from '@/components/home/client-testimonials';
import SimproFAQ from '@/components/faqs/simpro-faq';
import WhyChooseUs from '@/components/technologies/why-choose-us';
import SimproServies from '@/components/technologies/simpro-demand';

import DefaultBreadcrumb from '@/components/common/breadcrumbs';
import MetaTags from '@/components/meta-tag/meta-tag';
import Blog from '@/components/home/blog';

const ContactInfo = dynamic(() => import('@/components/common/contact-info'));
const ContactForm = dynamic(() => import('@/components/common/contact-form'));

const TechHeroApp = dynamic(() => import('@/components/technologies/tech-hero-app'));
const ContetVideoSection = dynamic(() => import('@/components/common/content-video'));
const Page = () => {
    return (
        <>
            <MetaTags />
            <TechHeroApp
                className=""
                desc="Optimize your organization's operations with our skilled simPRO developers who excel in custom simPRO development, delivering bespoke features and functionalities to enhance efficiency and effectiveness."
                alt="hero image"
                title="hero image"
                width={582}
                height={550}
                path={'simpro-hero'}
                bgPath={'hero-bg-grunge-orange'}
                color="orange"
                isOrange={true}
            >
                Custom simPRO <div>Development Company</div>
            </TechHeroApp>

            <DefaultBreadcrumb parentPage="Technologies" isParent={true} currentPage="Custom simPRO" />
            <ContetVideoSection title="Unlock the Full Potential of simPRO with Our Bespoke Development Services">
                <>
                    <p className="fw-400 text-secondary fs-md mb-0">
                        We specialize in creating customized solutions that cater to your unique field service management needs.
                        With our bespoke development for simPRO, we can tailor the software to align perfectly with your
                        workflows, processes, and industry requirements. From custom module development and workflow optimization
                        to seamless integrations and personalized reporting, our experienced team of developers will work closely
                        with you to understand your business goals and deliver a solution that empowers your operations.
                        Experience enhanced efficiency, improved user experience, and a competitive edge with our bespoke
                        development services for simPRO. Contact us today to discuss your requirements and embark on a journey
                        toward optimized field service management.
                    </p>
                </>
            </ContetVideoSection>
            <SimproServies />
            <HireProcess
                bg="bg-simpro"
                pageTitle="Hire Custom simPRO Developers To Build Cutting-Edge Digital Products"
                desc="Get a free consultation from our experts who will brainstorm your project idea to convert it into an advanced digital product using Custom simPRO."
            />
            <WhyChooseUs pageTitle="Why Choose Moweb For simPRO Development? " />
            <ModelsOfWorking
                title="Engagement Models To Hire The Best simPRO Developers"
                desc="Select from different engagement models to hire Custom simPRO Developers for your business needs. Different types of engagements allow you to find an optimal match for your company’s specific needs; whether that means hiring expert developers, or being flexible enough to change when necessary."
            />

            <TechnologyFaq title="FAQs On simPRO Development" bg="bg-simpro">
                <SimproFAQ />
            </TechnologyFaq>
            <CaseStudies />
            <section className="">
                <ClientTestimonials />
            </section>
            <Blog />
            <div className="section bg-primary py-100 dark:text-light dark:bg-black">
                <div className="container lg:container md:mx-auto">
                    <div className="row grid md:grid-cols-12 lg:grid-cols-12">
                        <ContactForm />
                        <ContactInfo />
                    </div>
                </div>
            </div>
        </>
    );
};

export default Page;
